import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeNotification } from '../../store/slices/notificationSlice';
import { CheckCircleIcon, XCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

const icons = {
  success: CheckCircleIcon,
  error: XCircleIcon,
  warning: ExclamationTriangleIcon,
  info: InformationCircleIcon,
};

const colors = {
  success: 'bg-emerald-50 border-emerald-200 text-emerald-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
  info: 'bg-blue-50 border-blue-200 text-blue-800',
};

const iconColors = {
  success: 'text-emerald-500',
  error: 'text-red-500',
  warning: 'text-amber-500',
  info: 'text-blue-500',
};

const NotificationItem = ({ notification, onClose }) => {
  const Icon = icons[notification.type] || icons.info;

  useEffect(() => {
    if (notification.duration > 0) {
      const timer = setTimeout(() => {
        onClose(notification.id);
      }, notification.duration);
      return () => clearTimeout(timer);
    }
  }, [notification.id, notification.duration, onClose]);

  return (
    <div
      style={{ 
        animation: 'slideLeft 0.3s ease-out',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }}
      className={`flex items-center gap-3 px-4 py-3 rounded-xl border ${
        colors[notification.type] || colors.info
      }`}
    >
      <Icon className={`w-5 h-5 flex-shrink-0 ${iconColors[notification.type] || iconColors.info}`} />
      <p className="font-medium flex-1 text-sm">{notification.message}</p>
      <button
        onClick={() => onClose(notification.id)}
        className="p-1 hover:bg-black/10 rounded-lg flex-shrink-0"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

const NotificationProvider = ({ children }) => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notification?.notifications || []);

  const handleClose = (id) => {
    dispatch(removeNotification(id));
  };

  return (
    <>
      {children}
      {/* Notification Container */}
      <div 
        className="fixed top-20 right-4 space-y-2 max-w-sm"
        style={{ zIndex: 99999, pointerEvents: notifications.length > 0 ? 'auto' : 'none' }}
      >
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onClose={handleClose}
          />
        ))}
      </div>
    </>
  );
};

export default NotificationProvider;
